const getConstants = require('../../../utils/getConstants');
const classifyRepeaterEntryMode = require('./classifyRepeaterEntryMode');

const { repeaterCadenceTypes, repeaterFormItemTypes } = getConstants();

const CAPTURE_LIMIT_REASON = (count) => `You are only allowed to capture ${count} entries.`;
const EXHAUSTED_LIST_REASON = 'You have already captured all possible entries.';

function matchesCanonicalId(value, id) {
   return value === id || value === String(id);
}

function hasUsableResolvedListOptions(listOptions) {
   return (
      Array.isArray(listOptions) &&
      listOptions.every((option) => option && option.id != null && ['string', 'number'].includes(typeof option.id))
   );
}

function hasUnusedListOption(listOptions, childItems) {
   const consumedIds = new Set(
      (childItems || [])
         .map((child) => child && child.response && child.response.val)
         .filter((value) => value != null)
         .map((value) => String(value))
   );

   return listOptions.some((option) => !consumedIds.has(String(option.id)));
}

function evaluateRepeaterAddPossibility({ item, childItems = [] }) {
   const options = (item && item.options) || {};
   const children = Array.isArray(childItems) ? childItems : [];
   const classification = classifyRepeaterEntryMode({
      idRepeaterType: options.idRepeaterType,
      entryMode: options.entryMode,
      idRepeaterCadence: options.idRepeaterCadence,
      timesToRepeat: options.timesToRepeat
   });

   if (classification.kind === classifyRepeaterEntryMode.kinds.CANONICAL_FULL_LIST) {
      return {
         canAdd: false,
         reason:
            item && item.repeaterMaterialized === true
               ? 'Full list membership is fixed.'
               : 'Full list membership is materialised automatically.'
      };
   }

   const hasReachedCaptureLimit =
      (matchesCanonicalId(options.idRepeaterCadence, repeaterCadenceTypes.EXACTLY.id) ||
         matchesCanonicalId(options.idRepeaterCadence, repeaterCadenceTypes.AT_MOST.id)) &&
      options.timesToRepeat === children.length;

   if (hasReachedCaptureLimit) {
      return {
         canAdd: false,
         reason: CAPTURE_LIMIT_REASON(options.timesToRepeat)
      };
   }

   const isList = matchesCanonicalId(options.idRepeaterType, repeaterFormItemTypes.LIST.id);
   const isClassifiedListMode = classification.kind !== classifyRepeaterEntryMode.kinds.MALFORMED;
   const hasResolvedList = hasUsableResolvedListOptions(options.listOptions);

   if (isList && isClassifiedListMode && hasResolvedList && !hasUnusedListOption(options.listOptions, children)) {
      return {
         canAdd: false,
         reason: EXHAUSTED_LIST_REASON
      };
   }

   return {
      canAdd: true,
      reason: ''
   };
}

module.exports = evaluateRepeaterAddPossibility;
